import { Component, OnInit } from '@angular/core';

import { ELEMENTS } from 'src/app/data/elements';
import { ZonesPropertiesService } from 'src/app/service/zones-properties.service';
import { ZoneProperties } from 'src/app/model/zone-properties';
import { DATA } from 'src/app/data/data';
import { ApiService } from 'src/app/service/api.service';
import { FlatroofZoningRooms } from 'src/app/model/flatroof-zoning-rooms';
import { DataService } from 'src/app/service/data.service';
import { ElementsService } from 'src/app/service/elements.service';
import { Subscription } from 'rxjs';
import { CanvasStateService } from 'src/app/service/canvas-state.service';

@Component({
  selector: 'app-roof-form',
  templateUrl: './roof-form.component.html',
  styleUrls: ['./roof-form.component.less']
})
export class RoofFormComponent implements OnInit {

  subscription: Subscription;
  
  selectedZone:ZoneProperties;
  zones:ZoneProperties[]=[];
  selectedId:number = -1;
  color:string;

  data:any=DATA;
  rooms: FlatroofZoningRooms[];
  fields = {
    thermal: {
      check: false,
      select: false
    },
    acoustic: {
      check: false,
      select: false
    },
    rainNoise: {
      check: false,
      select: false
    },
    strength: {
      check: false,
      select: false
    },
    pointLoad: {
      check: false,
      select: false
    },
  }

  constructor(
    private zonesPropertiesService: ZonesPropertiesService,
    private dataService: DataService,
    public elementsService: ElementsService,
    private canvasStateService:CanvasStateService
    ) { 
    this.dataService.populateRoomsDataFromDb();
    this.data=this.dataService.currentData;
    this.zonesPropertiesService.setZonesDefaults();
    this.zones=this.zonesPropertiesService.zonesProperties;
    this.changeValues() 
    this.setDisabledFields();
  }

  ngOnInit() {
    this.subscription = this.elementsService.elements$.subscribe(data => {
      this.zonesPropertiesService.addZones(data['zones'])
      this.zonesPropertiesService.setZonesDefaults();
      this.setDisabledFields();
      // this.initZones()
    });
    
    this.subscription = this.canvasStateService.canvasState$.subscribe(data => {
      if(data.type!=null)
        this.selectedId=parseInt(data.type);
        this.selectedZone=this.zonesPropertiesService.getZoneProperties(this.selectedId);
        
        if(this.selectedZone.id>=0){
          // this.canvasStateService.setState('highlightZone',true,this.selectedZone.id)
          this.color=this.elementsService.getZoneById(this.selectedId).color
        }else{
          // this.canvasStateService.setState('highlightContour',true)
          this.color='white';
        }
        this.zonesPropertiesService.setZonesDefaults();
        this.setDisabledFields()
      // this.initZones()
    });

    this.elementsService.calculateAreas()
    this.zonesPropertiesService.appendNames(this.elementsService.getContour(),this.elementsService.getZones())
    this.zonesPropertiesService.setZonesDefaults();
    this.zones=this.zonesPropertiesService.zonesProperties;
    this.setDisabledFields()
  }

  initZones(){
    this.zonesPropertiesService.addZones(this.elementsService.getZones());
    this.zones=this.zonesPropertiesService.zonesProperties;
    
    this.changeValues()    
  }

  setDisabledFields(){
        
    this.fields.thermal.check = false
    this.fields.thermal.select = false
    this.fields.acoustic.check = false
    this.fields.acoustic.select = false
    this.fields.rainNoise.check = false
    this.fields.rainNoise.select = false
    this.fields.strength.check = false
    this.fields.strength.select = false
    this.fields.pointLoad.check = false
    this.fields.pointLoad.select = false
    
    if(this.zones[0].id!=this.selectedZone.id && this.zones[0].thermal.ifActive){
      this.fields.thermal.check = true
      this.fields.thermal.select = true
    }
    if(this.selectedZone.type == 1){
      // this.fields.acoustic.check = true
      // this.fields.acoustic.select = true
      // this.fields.rainNoise.check = true
      // this.fields.rainNoise.select = true
      this.fields.strength.check = true
      this.fields.strength.select = true
      this.fields.pointLoad.check = true
      this.fields.pointLoad.select = true

    }else if(this.selectedZone.type == 2){
      this.fields.thermal.check = true
      this.fields.thermal.select = true
      this.fields.acoustic.check = true
      this.fields.acoustic.select = true
      this.fields.rainNoise.check = true
      this.fields.rainNoise.select = true
      this.fields.strength.check = true
      this.fields.strength.select = true
      this.fields.pointLoad.check = true
      this.fields.pointLoad.select = true

    }else if(this.selectedZone.type == 4){
      this.fields.thermal.check = true
      this.fields.thermal.select = true
      this.fields.acoustic.check = true
      this.fields.acoustic.select = true
      this.fields.rainNoise.check = true
      this.fields.rainNoise.select = true
      this.fields.strength.check = true
      this.fields.strength.select = true
      this.fields.pointLoad.check = true
      this.fields.pointLoad.select = true

    }else if(this.selectedZone.type==0 || this.selectedZone.type==3 || this.selectedZone.type==5){
      if(this.selectedZone.acoustic.ifActive == true || this.selectedZone.rainNoise.ifActive == true ){
        this.fields.strength.check = true
        this.fields.strength.select = true
        this.fields.pointLoad.check = true
        this.fields.pointLoad.select = true
      }
    }
  }

  checkData(){
    this.setDisabledFields();
    this.zonesPropertiesService.setZonesDefaults();
  }
  changeValues(){
    
    this.zones=this.zonesPropertiesService.zonesProperties;
    this.selectedZone=this.zonesPropertiesService.getZoneProperties(this.selectedId);
    if(this.selectedZone.id>=0){
      this.canvasStateService.setState('highlightZone',true,this.selectedZone.id)
      this.color=this.elementsService.getZoneById(this.selectedId).color
    }else{
      this.canvasStateService.setState('highlightContour',true)
      this.color='white';
    }
    // if(this.zones.length>1){
      // for(let i=1;i<this.zones.length;i++){
        // if(this.zones[0].thermal.ifActive){
        //   this.zones[i].thermal.ifActive=this.zones[0].thermal.ifActive
        //   this.zones[i].thermal.selected=this.zones[0].thermal.selected
        // }
        // if(this.zones[0].acoustic.ifActive){
        //   this.zones[i].acoustic.ifActive=this.zones[0].acoustic.ifActive
        //   this.zones[i].acoustic.selected=this.zones[0].acoustic.selected
        // }
        // if(this.zones[0].rainNoise.ifActive){
        //   this.zones[i].rainNoise.ifActive=this.zones[0].rainNoise.ifActive
        //   this.zones[i].rainNoise.selectedRoom=this.zones[0].rainNoise.selectedRoom
        //   this.zones[i].rainNoise.selectedWork=this.zones[0].rainNoise.selectedWork        
        //   this.zones[i].rainNoise.roomHeight=this.zones[0].rainNoise.roomHeight
        // }
        // if(this.zones[0].pointLoad.ifActive){
        //   this.zones[i].pointLoad.ifActive=this.zones[0].pointLoad.ifActive
        //   this.zones[i].pointLoad.selected=this.zones[0].pointLoad.selected
        // }
        // if(this.zones[0].compresiveStrength.ifActive){
        //   this.zones[i].compresiveStrength.ifActive=this.zones[0].compresiveStrength.ifActive
        //   this.zones[i].compresiveStrength.selected=this.zones[0].compresiveStrength.selected
        // }
      // }
    // }
      
    this.setDisabledFields()
  }

}
